module.exports = __webpack_public_path__ + "img/magic flight.7b0a8e2c.png";